// extracted by mini-css-extract-plugin
module.exports = {"input":"CurrencyInput_input__YEWWr","is-error":"CurrencyInput_is-error__K8KLV"};